import { render, staticRenderFns } from "./format-banner-shortcasts-image.vue?vue&type=template&id=1740dd02&scoped=true&"
import script from "./format-banner-shortcasts-image.vue?vue&type=script&lang=js&"
export * from "./format-banner-shortcasts-image.vue?vue&type=script&lang=js&"
import style0 from "./format-banner-shortcasts-image.vue?vue&type=style&index=0&id=1740dd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740dd02",
  null
  
)

export default component.exports